export default "__VITE_ASSET__80212308__"